/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from "react";
import cx from "clsx";
import LinesEllipsis from "react-lines-ellipsis";
import { ConfirmModal } from "../../boxes/ConfirmModal/ConfirmModal";
import { MarkdownContent } from "../../shared/MarkdownContent/MarkdownContent";
import { not } from "../../utilities/fp";
import styles from "./styles/ReadFullNote.module.scss";

export const ReadFullNote = ({ text, title }) => {
  const [showFullText, setShowFullText] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const containerRef = useRef(null);

  const toggleShowFullText = () => {
    setShowFullText(not);
  };

  useEffect(() => {
    const el = containerRef.current;
    if (el) {
      setIsOverflowing(el.scrollHeight > el.clientHeight);
    }
  }, [text]);

  return (
    <div>
      <div
        ref={containerRef}
        className={cx(styles.limitedText, {
          [styles.overflowing]: isOverflowing && !showFullText,
        })}
      >
        <MarkdownContent>{text}</MarkdownContent>
      </div>
      {isOverflowing && (
        <span onClick={toggleShowFullText} className="read-more">
          Read more
        </span>
      )}
      {showFullText && (
        <ConfirmModal
          isOpen
          title={
            <div className="word-wrap-break">
              <LinesEllipsis
                maxLine={2}
                ellipsis={"..."}
                basedOn="letters"
                text={title}
              />
            </div>
          }
          onConfirm={toggleShowFullText}
          confirmTitle="Ok"
        >
          <MarkdownContent>{text}</MarkdownContent>
        </ConfirmModal>
      )}
    </div>
  );
};
